import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

import Hamburger from '../../../common/assets/hamburger'

class Menu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false,
    }

    this.sections = React.createRef()

    this.toggleVisibility = this.toggleVisibility.bind(this)
  }

  isCurrentAt(pathnameString) {
    const {
      pathname
    } = this.props.location

    if (pathname !== pathnameString) {
      return ''
    }

    return ' menu__item--current'
  }

  toggleVisibility() {
    this.setState({
      visible: this.state.visible ? false : true,
    })
  }

  render() {
    const styles = {
      overlay: {
        opacity: this.state.visible ? '1' : '0',
        transitionDuration: this.state.visible ? '.8s' : '.2s',
        visibility: this.state.visible ? 'visible' : 'hidden',
      },
      sections: {
        transform: this.state.visible ? `translate3d(calc(100% - 1px),0,0)` : `translate3d(-100%,0,0)`,
      },
    }

    return (
      <div className="menu">
        <div
          className="menu__overlay"
          style={styles.overlay}
          onTouchEnd={this.toggleVisibility}
        />
        <div className="menu__button" onClick={this.toggleVisibility}>
          <span className="menu__text">Menu</span>
          <span className="menu__icon"><Hamburger /></span>
        </div>
        <div className="menu__dropdown" style={styles.dropdown}>
          <div className="menu__sections" ref={this.sections} style={styles.sections}>
            <div className="menu__section">
              <ul className="menu__list menu__list--primary">
                <li className={`menu__item${this.isCurrentAt('/browse')}`}>
                  <Link className="menu__link" to="/browse">Home</Link>
                </li>
                {/* <li className={`menu__item${this.isCurrentAt('/')}`}>
                  <Link className="menu__link" to="/browse/genre/my-list">My List</Link>
                </li> */}
                <li className={`menu__item${this.isCurrentAt('/browse/genre/recently-added')}`}>
                  <Link className="menu__link" to="/browse/genre/recently-added">Recently Added</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/latest-videos')}`}>
                  <Link className="menu__link" to="/browse/genre/latest-videos">Latest Videos</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/full-length-videos')}`}>
                  <Link className="menu__link" to="/browse/genre/full-length-videos">Full-Length Videos</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/parts')}`}>
                  <Link className="menu__link" to="/browse/genre/parts">Parts</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/contests')}`}>
                  <Link className="menu__link" to="/browse/genre/contests">Contests</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/shows')}`}>
                  <Link className="menu__link" to="/browse/genre/shows">Shows</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/documentaries')}`}>
                  <Link className="menu__link" to="/browse/genre/documentaries">Documentaries</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/shop-and-homie-videos')}`}>
                  <Link className="menu__link" to="/browse/genre/shop-and-homie-videos">Shop & Homie Videos</Link>
                </li>
                <li className={`menu__item${this.isCurrentAt('/browse/genre/tours')}`}>
                  <Link className="menu__link" to="/browse/genre/tours">Tours</Link>
                </li>
              </ul>
            </div>
            <div className="menu__section">
              <ul className="menu__list menu__list--primary">
                <li className={`menu__item${this.isCurrentAt('/')}`}>
                  <Link className="menu__link" to="/">Sign Out</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Menu)



// WEBPACK FOOTER //
// ./src/mobile/components/menu/index.js